var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":_vm.dialog.maxWidth,"persistent":""},model:{value:(_vm.dialog.show),callback:function ($$v) {_vm.$set(_vm.dialog, "show", $$v)},expression:"dialog.show"}},[_c(_vm.dialog.name,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }